import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { login } from "../../api/webServices";
import { changeSessionData } from "../../store/reducers/sessionSlice";
import Alert from "../UI/Alert/Alert";
import Button from "../UI/Button/Button";
import './Login.css'
import { FaRegUser } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi'

const Login = () => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { sessionData } = useSelector(state => state.session);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    if (sessionData) {
        return <Navigate to='/dashboard' replace={true} />
    }

    const handleChangeInput = (e) => {
        let id = e.target.id;
        if (id === "username") setUsername(e.target.value);
        if (id === "password") setPassword(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        login({ username: username, password: password })
            .then(res => {
                if (res?.status === 200) {
                    if (res?.data?.success) {
                        let { username, role, name } = res.data?.user;
                        dispatch(changeSessionData({ username, role, name }));
                        navigate('/');
                    } else {
                        setError(res?.data?.message);
                        setTimeout(() => {
                            setError(null);
                        }, 5000);
                    }
                }
            }).catch(err => {
                setError(err?.response?.data?.mensaje);
                setTimeout(() => {
                    setError(null);
                }, 5000);
            }).finally(
                () => { setLoading(false) }
            );
    }

    return (
        <div className="grid w-full h-screen loginScreen max-w place-items-center">
            <form className="w-8/12 px-8 pt-6 pb-8 mb-2 rounded loginForm xl:w-[370px] sm:8/12 md:w-4/12" onSubmit={handleSubmit}>
                <h2 className="py-10 text-4xl text-center">Iniciar sesión</h2>
                <div className="mb-4">
                    <label className="block mb-2 text-sm font-bold text-gray-500" htmlFor="username">
                        Usuario
                    </label>
                    <div className="flex flex-row items-center gap-2">
                        <FaRegUser size={20} />
                        <input
                            className="w-full px-3 py-2 leading-tight text-gray-900 border rounded appearance-none"
                            type="text"
                            id="username"
                            onChange={handleChangeInput}
                            value={username}
                            placeholder="Username"
                        />
                    </div>
                </div>
                <div className="mb-4">
                    <label className="block mb-2 text-sm font-bold text-gray-500" htmlFor="password">
                        Contraseña
                    </label>
                    <div className="flex flex-row items-center gap-2 mb-10">
                        <FiLock size={20} />
                        <input
                            className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                            type="password"
                            id="password"
                            onChange={handleChangeInput}
                            value={password}
                            placeholder="************"
                        />
                    </div>
                </div>
                <div className="flex flex-col items-center justify-between gap-3">
                    {error && <Alert title={'Error'} text={error} />}
                    <Button
                        type={'primary'}
                        width={'full'}
                        text={loading ? 'Cargando...' : 'Ingresar'}
                    />
                </div>
            </form>
        </div>
    )
}

export default Login;